import React from 'react';
import {
  Flex,
  useColorMode,
  useIsMobileView,
  Text,
  color,
  typography,
} from 'deepstash-ui';
import ReactHtmlParser from 'react-html-parser';
import { StoryApiResponse } from 'api/api.types';
import { makeTransformHtmlParserStoryTOC } from 'utils/html-utils';

const TABLE_OF_CONTENTS = 'Table of Contents';

interface StoryPageTOCProps {
  story: StoryApiResponse;
}

const StoryPageTOC: React.FC<StoryPageTOCProps> = ({ story }) => {
  const isMobileView = useIsMobileView();
  const { colorMode } = useColorMode();

  const parsedHtml = React.useMemo(() => {
    return ReactHtmlParser(story.table_of_content, {
      transform: makeTransformHtmlParserStoryTOC({ colorMode: colorMode }),
    });
  }, [story.table_of_content]);

  return (
    <Flex
      flexDirection="column"
      {...(isMobileView ? {} : { position: 'sticky', top: 62 })}
    >
      <Text
        {...typography.primaryTextFonts.large.bold}
        color={color.light.textSecondary}
        textTransform="uppercase"
        letterSpacing={2}
      >
        {TABLE_OF_CONTENTS}
      </Text>
      <Flex>
        <Text {...typography.primaryTextFonts.medium.semiBold}>
          {parsedHtml}
        </Text>
      </Flex>
    </Flex>
  );
};

export default StoryPageTOC;
